import * as React from 'react';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';

const PagingPanelContainer = (props: PagingPanel.ContainerProps) => {
  return <PagingPanel.Container {...props} />;
};

export { PagingPanelContainer };
